class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.querySelector('[data-ct-notification-backdrop]')?.addEventListener('click', () => this.close());
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // Escape sticky-header stacking contexts without replacing the component.
    if (this.parentElement !== document.body) document.body.appendChild(this);
    this.classList.add('ct-notification-open');
    document.body.classList.add('ct-cart-notification-open');
    this.notification.classList.add('animate', 'active');

    requestAnimationFrame(() => {
      if (!this.notification.classList.contains('active')) return;
      this.notification.focus();
      trapFocus(this.notification);
    });

    document.body.addEventListener('click', this.onBodyClick);

    // Keep analytics work out of the first visible notification frame.
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (this.notification.classList.contains('active')) this.dispatchCartViewEvent();
      }, 0);
    });
  }

  // Reuse the post-add cart request started by product-form. The notification
  // still needs the full cart shape for Shopify's cart:view event, but it does
  // not need to make a duplicate network request for the same data.
  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const cart = window.CTCartData
        ? await window.CTCartData.fetch()
        : await fetch(`${routes.cart_url}.json`).then((response) => response.json());
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // cart:view is informational; swallow fetch errors
    }
  }

  close() {
    this.notification.classList.remove('active');
    this.classList.remove('ct-notification-open');
    document.body.classList.remove('ct-cart-notification-open');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if (
        section.id === 'cart-icon-bubble' &&
        window.CTCartHeader?.renderFromSection(parsedState.sections[section.id])
      ) {
        return;
      }

      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const viewCartButton = this.querySelector('#cart-notification-button');
    if (viewCartButton?.dataset.ctViewCartLabel) {
      viewCartButton.textContent = viewCartButton.dataset.ctViewCartLabel;
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
